import { u as t } from "../styled-components.browser.esm-3eb04950.js";
const i = t.div`
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: -2%;
`;
export {
  i as ContentTitle
};
//# sourceMappingURL=Content.Title.js.map
